<div class="container welcome">
  <mat-progress-spinner class="spinner" mode="indeterminate"
    [style.visibility]="showProgress() ? 'visible' : 'hidden'">
  </mat-progress-spinner>

  <div class="hero">
    <!-- Inline SVG (not mat-icon) so the LCP element doesn't block on the Material Icons woff2 download. -->
    <svg class="hero-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
      <path fill="currentColor" d="M18,8h-1V6c0-2.76-2.24-5-5-5S7,3.24,7,6v2H6c-1.1,0-2,0.9-2,2v10c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2V10 C20,8.9,19.1,8,18,8z M8.9,6c0-1.71,1.39-3.1,3.1-3.1s3.1,1.39,3.1,3.1v2H8.9V6z M16,16h-3v3h-2v-3H8v-2h3v-3h2v3h3V16z"/>
    </svg>
    <h1 class="title">Quick Crypt</h1>
    <p class="tagline">Easy, Trustworthy Personal Encryption</p>
  </div>

  <div class="features">
    <div class="feature">
      <mat-icon class="feature-icon">lock</mat-icon>
      <span>Encrypt files and notes with strong,&nbsp;modern&nbsp;cryptography.</span>
    </div>
    <div class="feature">
      <mat-icon class="feature-icon">fingerprint</mat-icon>
      <span>No accounts to manage, just passkeys you control.</span>
    </div>
    <div class="feature">
      <mat-icon class="feature-icon">code</mat-icon>
      <span>End-to-end encrypted,
        <a href="https://github.com/bschick/qcrypt" target="_blank">open source</a>, and free to use.</span>
    </div>
  </div>

  <mat-divider class="section-divider"></mat-divider>

  <div class="actions">
    <div class="button-column">
      <a [routerLink]="'/newuser'">
        <button mat-raised-button class="action-button primary-action">
          <mat-icon>vpn_key</mat-icon><span>I am new to Quick Crypt</span>
        </button>
      </a>
      <button mat-raised-button (click)="onClickExisting($event)" class="action-button">
        <mat-icon>login</mat-icon><span>I have used Quick Crypt previously</span>
      </button>
      <button mat-flat-button (click)="onClickRecovery($event)" class="recovery-button">
        <mat-icon>help</mat-icon><span>I am returning but cannot sign in</span>
      </button>
    </div>
  </div>

  @if (error()) {
    <p class="error-msg">{{error()}}</p>
  }

  <nav class="footer-links">
    <a [routerLink]="'/help/overview'">Overview</a>
    <span class="dot"></span>
    <a [routerLink]="'/help/faqs'">FAQs</a>
    <span class="dot"></span>
    <a [routerLink]="'/help/protocol'">Protocol</a>
  </nav>
</div>
